import LOCALSTORAGE_KEYS from '@web/consts/LOCALSTORAGE_KEYS'
import { clearUserScoped, readUserScoped, writeUserScoped } from './storage'
import type { OnboardingProgress } from './types'

function isOnboardingProgress (value: unknown): value is OnboardingProgress {
  if (typeof value !== 'object' || value === null) return false
  const obj = value as Record<string, unknown>
  return typeof obj.slug === 'string' && obj.slug.length > 0 &&
    typeof obj.step === 'string' && obj.step.length > 0
}

export function readOnboardingProgress (): OnboardingProgress | null {
  return readUserScoped(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS_PREFIX, isOnboardingProgress)
}

export function writeOnboardingProgress (progress: OnboardingProgress): void {
  writeUserScoped(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS_PREFIX, progress)
}

export function clearOnboardingProgress (): void {
  clearUserScoped(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS_PREFIX)
}

/**
 * Старые ключи (глобальный прогресс и числовой шаг) не мигрируются —
 * просто удаляются. Юзеры в середине онбоарда начнут сценарий заново.
 */
export function dropLegacyOnboardingKeys (): void {
  localStorage.removeItem(LOCALSTORAGE_KEYS.ONBOARDING_STEP_KEY)
  localStorage.removeItem(LOCALSTORAGE_KEYS.ONBOARDING_PROGRESS)
}
